export const ACTIVE = "Active";
export const STOPPED = "Stopped";
export const ARCHIVED = "Archived";